// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"49":"055f4cd2","341":"0305a305","455":"0a034769","919":"87e58dea"}[chunkId] + ".chunk.js";
};